<template>
  <footer>
    <img class="mobile-collage" :src="$t('Header.MobileCollage')" alt="" />
    <div class="footer-bar py-2">
      <div class="inner">
        <ul class="footer-links list-unstyled mb-0">
          <li v-html="$t('Footer.T&CLink')"></li>
          <li v-html="$t('Footer.PrivayPolicyLink')"></li>
        </ul>
        <div class="footer-social">
          <a :href="$t('Footer.FacebookUrl')" title="Facebook" target="_blank" rel="noopener">
            <i class="fab fa-facebook-f"></i>
          </a>
          <a :href="$t('Footer.InstagramUrl')" title="Instagram" target="_blank" rel="noopener">
            <i class="fab fa-instagram"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="footer-legal py-3">
      <div class="inner">
        <p class="footer-copyright mb-2">
          {{ $t('Footer.copyrighttext') }}
        </p>
        <div class="footer-finerprint mb-0" v-html="$t('Footer.legalrules')"></div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'TheFooter',
  mounted() {
    // Dynamically fetch the translated modelHash
    const modelHash = this.$t('YounetmodelHash');
    const modelImgurl = this.$t('YounetmodelIMg');
    const scriptUrl = `https://widget.younet.ai/index.js?modelHash=${modelHash}&type=bubble&imgUrl=${modelImgurl}`;

    // Dynamically create the script element
    const script = document.createElement('script');
    script.type = 'module';
    script.src = scriptUrl;

    // Append the script to the body
    document.body.appendChild(script);
  },
};
</script>
